module.exports = __webpack_public_path__ + "static/flags/PS-a7acabb5e4e7b890cf46207b3625d3f5.gif";